<template>
  <!-- //header -->
  <div id="dashBoardHeader" class="dashboard-header">
    <div class="dashboard-header__inner">
      <!-- S : 20230315 대시보드 업데이트 -->
      <div class="dashboard-header__user">
        <span class="user-name">{{abo}}</span>
        <span class="user-num">({{name}})</span>
      </div>
      <h1 class="dashboard-header__title">2023년 3월 <br class="mo"/>신규 ABO 프로모션 후원 현황</h1>
      <a href="https://www.amway.co.kr/main" class="dashboard-header__link">
        <span class="logo">
          <span class="hidden">Amway</span>
        </span>
        홈으로 >
      </a>
    </div>
  </div>
  <!-- //header -->
</template>

<script >
export default {
  props: ['abo', 'name']
}
</script>
<style scoped>
@import '../assest/css/abo.css';
</style>



// WEBPACK FOOTER //
// src/views/sales/dashboard2/component/header.vue